import { isPresent } from '@ember/utils';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { isTruthy } from 'linced-admin/utils/strings';

const numericOperators = /^[<>]=?/;

function filterNumeric(filter, value) {
  if (numericOperators.test(filter)) {
    let operator = filter.match(numericOperators)[0];
    let remainder = filter.replace(numericOperators, '').trim();
    let filterValue = Number(remainder);
    if (isNaN(filterValue)) {
      // No valid number to check against - match everything if no value yet, nothing if there's an invalid value
      return remainder.length === 0;
    }
    switch (operator) {
      case '>':
        return value > filterValue;
      case '>=':
        return value >= filterValue;
      case '<':
        return value < filterValue;
      case '<=':
        return value <= filterValue;
    }
    return false;
  } else {
    return value === Number(filter.trim());
  }
}

export function filterValue(value, datatype, filter) {
  let include = true;
  let negated = false;

  if (filter.charAt(0) === '!') {
    // Negated filter - flag and remove the leading "!"
    negated = true;
    filter = filter.substring(1).trim();
  }

  switch (datatype) {
    case DataType.STRING:
      if (filter === '*') {
        include = isPresent(value);
      } else if (value.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
        include = false;
      }
      break;
    case DataType.BOOLEAN:
      if (filter === '*') {
        include = isPresent(value);
      } else {
        include = isTruthy(filter) === Boolean(value);
      }
      break;
    case DataType.INTEGER:
    case DataType.FLOAT:
      if (filter === '*') {
        include = isPresent(value);
      } else {
        include = filterNumeric(filter, value);
      }
      break;
    case undefined: // No value for this field
      include = false;
      break;
  }

  if (negated) {
    include = !include;
  }

  return include;
}
